// extracted by mini-css-extract-plugin
export default {"root":"IconCategoryOmg_root__yFXL9"};